// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlaceholderHeaderCss_pl4erzr{height:60px;background:var(--gray00);}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-header/dist/es/index.css"],"names":[],"mappings":"AAAA,8BAA8B,WAAW,CAAC,wBAAwB,CAAC","sourcesContent":[".PlaceholderHeaderCss_pl4erzr{height:60px;background:var(--gray00);}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
